const STORAGE_PREFIX = "couples:anniversary-celebrated:";

/**
 * 記念日の演出(モーダル・紙吹雪)をその日すでに見せたか。
 * ユーザーごと・日付ごとに1回だけにするため、DBではなく端末の localStorage に記録する
 * (端末=ユーザーの前提で十分で、DBに書くほどのものではないため)。
 */
export function hasCelebratedToday(userId: string, todayKey: string): boolean {
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${todayKey}:${userId}`) !== null;
  } catch {
    return false;
  }
}

export function markCelebratedToday(userId: string, todayKey: string): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${todayKey}:${userId}`, "1");
  } catch {
    // 保存できない環境(プライベートモード等)では諦める。次に開いたときまた出るだけ
  }
}

/** 動作確認用。「見た」記録を消し、次に開いたときまた演出が出るようにする */
export function clearCelebratedToday(userId: string, todayKey: string): void {
  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${todayKey}:${userId}`);
  } catch {
    // 消せない環境なら何もしない
  }
}
